goog.provide("shadow.js.shim.module$src$svg$wpp$content$movie_svg$default");
shadow.js.shim.module$src$svg$wpp$content$movie_svg$default = shadow.js.shim.module$src$svg$wpp$content$movie_svg.default;
